// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import TemplateContract from '../../../../utils/TemplateContract';
import { usePartyBasedQuery } from '../../useOperatorBasedQuery';

const useRegistrarService: () => UseQueryResult<
  TemplateContract<RegistrarService> | null,
  string
> = () =>
  usePartyBasedQuery('queryRegistryRegistrarService', (ledgerApi, offset, operator, party) =>
    ledgerApi.queryRegistryRegistrarService(offset, operator, party),
  );

export default useRegistrarService;
